// Weekly livestream schedule shown on the Settings > Calendar tab.
// All times are Eastern wall-clock. startTime MUST stay zero-padded "HH:MM" —
// events are sorted with startTime.localeCompare, which is only chronological
// while every value is exactly five characters.
// days: ISO weekday numbers, 1 = Monday … 5 = Friday.
export const LIVESTREAM_SCHEDULE = [
  {
    id: "ws-everest",
    title: "Wealth Series Everest",
    requiredFlag: "hasWealthSeriesEverest",
    days: [3],
    startTime: "16:30",
    durationMinutes: 30,
    host: "Dane Glisek",
    route: "/wealth-series/everest?tab=livestream",
  },
  {
    id: "ws-titan",
    title: "Wealth Series Titan",
    requiredFlag: "hasWealthSeriesTitan",
    days: [2],
    startTime: "16:30",
    durationMinutes: 30,
    host: "Dane Glisek",
    route: "/wealth-series/titan?tab=livestream",
  },
  {
    id: "ws-atlas",
    title: "Wealth Series Atlas",
    requiredFlag: "hasWealthSeriesAtlas",
    days: [1],
    startTime: "16:30",
    durationMinutes: 30,
    host: "Dane Glisek",
    route: "/wealth-series/atlas?tab=livestream",
  },
  {
    id: "ws-core",
    title: "Wealth Series Core",
    requiredFlag: "hasWealthSeriesCore",
    days: [4],
    startTime: "14:30",
    durationMinutes: 30,
    host: "Dane Glisek",
    route: "/wealth-series/core?tab=livestream",
  },
  {
    id: "ws-lite",
    title: "Wealth Series Lite",
    requiredFlag: "hasWealthSeriesLite",
    days: [4],
    startTime: "16:30",
    durationMinutes: 30,
    host: "Dane Glisek",
    route: "/wealth-series-lite/livestream",
  },
  {
    id: "ls-training",
    title: "Live Training",
    requiredFlag: "canSeeInternal",
    days: [3],
    startTime: "12:00",
    durationMinutes: 60,
    host: "Dane Glisek",
    route: "/live-training",
  },
  {
    id: "ls-morning",
    title: "Live Trading Room (AM)",
    requiredFlag: "canSeeInternal",
    days: [1, 2, 3, 4, 5],
    startTime: "09:00",
    durationMinutes: 90,
    host: "Ross Santos",
    route: "/market-analysis",
  },
  {
    id: "ls-afternoon",
    title: "Live Trading Room (PM)",
    requiredFlag: "canSeeInternal",
    days: [1, 2, 3, 4, 5],
    startTime: "15:00",
    durationMinutes: 60,
    host: "Dane Glisek",
    route: "/market-analysis",
  },
  {
    id: "ls-brian",
    title: "DayTrade with Brian",
    requiredFlag: "canSeeInternal",
    days: [1, 2, 3, 4, 5],
    startTime: "10:30",
    durationMinutes: 60,
    host: "Brian Mitchell",
    route: "/live-chat/livestream",
  },
  {
    id: "ot-academy",
    title: "Options Academy",
    requiredFlag: "hasOptionsAcademy",
    days: [1, 2, 3, 4, 5],
    startTime: "14:00",
    durationMinutes: 60,
    host: "Dane Glisek",
    route: "/options-academy/livestream",
  },
  {
    id: "ot-academy-qa",
    title: "Options Academy Q&A",
    requiredFlag: "hasOptionsAcademy",
    days: [1, 2, 3, 4, 5],
    startTime: "11:30",
    durationMinutes: 30,
    host: "Dane Glisek",
    route: "/options-academy/livestream",
  },
  {
    id: "ot-platinum-roman",
    title: "Platinum",
    requiredFlag: "hasPlatinumProgram",
    days: [1, 2, 3, 4, 5],
    startTime: "09:30",
    durationMinutes: 60,
    host: "Roman Radenski",
    route: "/platinum-program/livestream",
  },
];

export const DAY_LABELS = {
  1: "Mon",
  2: "Tue",
  3: "Wed",
  4: "Thu",
  5: "Fri",
};

export const DAY_NAMES = {
  1: "Monday",
  2: "Tuesday",
  3: "Wednesday",
  4: "Thursday",
  5: "Friday",
};

export const WEEKDAYS = [1, 2, 3, 4, 5];
